export const VALIDATION_RULES = [
  { label: 'Required', value: 'required' },
  // { label: 'Valid Date', value: 'isValidDate' },
  { label: 'Is Number', value: 'isNumber' },
  { label: 'Positive Number', value: 'positiveNumber' },
  { label: 'Non-Negative Number', value: 'nonNegativeNumber' },
  { label: 'Percentage', value: 'percentage' },
  { label: 'Valid Year', value: 'validYear' },
  { label: 'Boolean', value: 'isBoolean' },
  // { label: 'Min Length', value: 'minLength' },
  // { label: 'Max Length', value: 'maxLength' },
  { label: 'Is Email', value: 'isEmail' },
  { label: 'Is Phone Number', value: 'isPhoneNumber' },
  { label: 'Is URL', value: 'isURL' },
  { label: 'Is String', value: 'isString' },
  { label: 'Is Zip Code', value: 'isZipCode' },
  { label: 'Between 0 to 100', value: 'between:0,100' },
];


export const FIELD_TYPES = [
  { label: 'Text', value: 'text' },
  { label: 'Number', value: 'number' },
  { label: 'Date', value: 'date' },
  { label: 'Email', value: 'email' },
  { label: 'Password', value: 'password' },
  { label: 'Checkbox', value: 'checkbox' },
  { label: 'Radio', value: 'radio' },
  { label: 'Select', value: 'select' },
  { label: 'Textarea', value: 'textarea' },
  { label: 'Range', value: 'range' },
  { label: 'Color', value: 'color' },
  { label: 'Image', value: 'image' },
  { label: 'Multiple Images', value: 'multipleImages' },
  { label: 'File', value: 'file' },
  { label: 'Multiple Files', value: 'multipleFiles' },
  { label: 'Time', value: 'time' },
  { label: 'Week', value: 'week' },
  { label: 'Month', value: 'month' },
  { label: 'Tel', value: 'tel' },
  { label: 'URL', value: 'url' }
];


export const BOOLEAN_OPTION_LABELS = [
  { label: 'True', value: true },
  { label: 'False', value: false }
];


export const SCHEMA_COLUMN_LAYOUT = {
  name: '',
  type: '',
  field: '',
  visible: '',
  validations: [],
  minValue: '',
  maxValue: '',
  description: '',
  unit: '',
  subunit: '',
  enable_adjustment: false,
  adustment_type: '',
  adjustment_formula: '',
  is_summary: false,
  show_header: false,
  header_title:''
};


export const SCHEMA_NAME = {
  SALES_HISTORY: 'sales_history',
  COMP_SALES_HISTORY: 'sales_comp',
  MARKET_SALES_HISTORY: 'market_sales_history',
  ADDITIONAL_COST: 'additional_cost',
  BUILDING_COST_REPLACEMENT: 'builiding_cost_replacement',
  BUILDING_COST: 'building_cost',
  COST_APPROACH: 'cost_approach',
  MARKET_ANALYSIS: 'market_analysis',
  DEPRECATION_COST: "deprecation_cost",
  LAND_IMPROVEMENTS: 'land_improvements',
  INSURANCE_COST: 'insurance_cost',
  INCOME: 'income',
  INCOME_COMP: 'income_comp',
  EXPENSE: 'expenses',
  EXPENSE_COMP: 'expense_comp',
  DCF: 'discount_cash_flow',
  BUILDING_IMPROVEMENTS: 'building_improvements',
  INTERIOR_IMPROVEMENTS: 'interior_improvements',
  SITE_IMPROVEMENTS: 'site_improvements',
  UTILITY_INFRASTRUCTURE: 'utility_infrastructure',
  ENERGY_EFFICIENCY: 'energy_efficiency',
  SPECIAL_FEATURES: 'special_features',
  ZONING_COMPLIANCE: 'zoning_compliance',
  PERMIT_CONSTRUCTION: 'permit_construction',
  LEASES:'leases',
  COMP_LEASES:'comp_leases',
  PROPERTIES:'properties',
  MORTGAGE_DETAILS:'mortgage_details',
  SURVEY_DETAILS:"survey-details",
  OWNERS:"owners",
  OWNERSHIP_CONTACTS: 'ownership_contact',
  WAGES:'wages_details',
  DEMOGRAPHIC:'demographic_details',
  OCCUPATIONAL:'occupational-details'
}

export const UNIT_TYPES = [
  { label: 'Currency', value: 'currency' },
  // { label: 'Amount', value: 'amount' },
  { label: 'Distance', value: 'distance' },
  { label: 'Time', value: 'time' },
  { label: 'Percentage', value: 'percentage' },
  // { label: 'Date', value: 'date' },
  { label: 'Time', value: 'time' },
];

export const SUB_UNIT_TYPES = {
  amount: [
    { label: 'currency', value: 'currency' },
  ],
  distance: [
    { label: 'Kilometers', value: 'km' },
    { label: 'Meters', value: 'm' },
    { label: 'Centimeters', value: 'cm' },
  ],
  time: [
    { label: 'Seconds', value: 'seconds' },
    { label: 'Minutes', value: 'minutes' },
    { label: 'Hours', value: 'hours' },
  ],
};


export const SUB_MARKET = [
  { id: 1, label: "Airport", value: "airport" },
  { id: 2, label: "Caldwell", value: "caldwell" },
  { id: 3, label: "Central Bench", value: "central_bench" },
  { id: 4, label: "Downtown", value: "downtown" },
  { id: 5, label: "Eagle", value: "eagle" },
  { id: 6, label: "Garden City", value: "garden_city" },
  { id: 7, label: "Kuna", value: "kuna" },
  { id: 8, label: "Meridian", value: "meridian" },
  { id: 9, label: "Middleton", value: "middleton" },
  { id: 10, label: "Nampa", value: "nampa" },
  { id: 11, label: "North Boise", value: "north_boise" },
  { id: 12, label: "North Nampa", value: "north_nampa" },
  { id: 13, label: "Northeast", value: "northeast" },
  { id: 14, label: "Northwest", value: "northwest" },
  { id: 15, label: "South Ada", value: "south_ada" },
  { id: 16, label: "South Canyon", value: "south_canyon" },
  { id: 17, label: "Southeast", value: "southeast" },
  { id: 18, label: "Southwest", value: "southwest" },
  { id: 19, label: "West Bench", value: "west_bench" },
  { id: 20, label: "West Canyon", value: "west_canyon" }
];


export const BUILDING_CLASSES = ['A', 'B', 'C', 'D', 'S'];
export const QUALATIVE_RATINGS = [
  { formControl:'qualitative_location',category: 'Location', values: ['Excellent', 'VeryGood', 'Good', 'AboveAverage', 'Average', 'BelowAverage', 'Fair'] },
  { formControl:'qualitative_condition',category: 'Condition', values: ['Excellent', 'VeryGood', 'Good', 'AboveAverage', 'Average', 'BelowAverage', 'Fair'] },
  {formControl:'qualitative_access', category: 'Access', values: ['Excellent', 'VeryGood', 'Good', 'AboveAverage', 'Average', 'BelowAverage', 'Fair'] },
  { formControl:'qualitative_exposure',category: 'Exposure', values: ['Excellent', 'VeryGood', 'Good', 'AboveAverage', 'Average', 'BelowAverage', 'Fair'] },
  { formControl:'qualitative_building',category: 'Quality', values: ['Excellent', 'VeryGood', 'Good', 'AboveAverage', 'Average', 'BelowAverage', 'Fair'] },
  { formControl:'qualitative_site_utility',category: 'Utility', values: ['Excellent', 'VeryGood', 'Good', 'AboveAverage', 'Average', 'BelowAverage', 'Fair'] },
  { formControl:'qualitative_appeal',category: 'Appeal', values: ['Excellent', 'VeryGood', 'Good', 'AboveAverage', 'Average', 'BelowAverage', 'Fair'] }
];



export const UNDER_CONSTRUCTION = [
  { id: 1, label: "Purposed", value: "purposed" },
  { id: 2, label: "Planned", value: "planned" },
  { id: 3, label: "Under Construction", value: "under_construction" },
  { id: 4, label: "On Hold", value: "on_hold" }
];
export const PROPERTY_TYPES = [
  {
    label: "Office",
    value: "office",
    subtypes: [
      { label: "General Office", value: "general_office" },
      { label: "Medical", value: "medical" },
      { label: "Low-Rise Office", value: "low-rise_office" },
      { label: "Low-Rise", value: "low-rise" },
      { label: "Mid-Rise", value: "mid-rise" },
      { label: "Other Office", value: "other_office" },
      { label: "Medical Office", value: "medical_office" },
      { label: "Mixed-use", value: "mixed-use" },
      { label: "High Rise", value: "high_rise" },
      { label: "Veterinary Clinic", value: "veterinary_clinic" },
      { label: "Office", value: "office" },
      { label: "Commercial", value: "commercial" },
      { label: "Business Park", value: "business_park" },
      { label: "Creative/Loft", value: "creative/loft" },
      { label: "Office Condominiums", value: "office_condominiums" }
    ]
  },
  {
    label: "Retail",
    value: "retail",
    subtypes: [
      { label: "Fitness", value: "fitness" },
      { label: "Restaurant (Sit-down)", value: "restaurant_(sit-down)" },
      { label: "Mix use", value: "mix_use" },
      { label: "Vet Clinic", value: "vet_clinic" },
      { label: "Department Store", value: "department_store" },
      { label: "Day Care Facility/Nursery", value: "day_care_facility/nursery" },
      { label: "Garden Center", value: "garden_center" },
      { label: "Car Wash", value: "car_wash" },
      { label: "Kennel", value: "kennel" },
      { label: "Day Care Facility", value: "day_care_facility" },
      { label: "Grocery Store", value: "grocery_store" },
      { label: "Convenience Store", value: "convenience_store" },
      { label: "Big Box", value: "big_box" },
      { label: "Mixed-use", value: "mixed-use" },
      { label: "Bank Branch", value: "bank_branch" },
      { label: "Shopping Center", value: "shopping_center" },
      { label: "Service Station/Gas Station", value: "service_station/gas_station" },
      { label: "Automotive", value: "automotive" },
      { label: "General Commercial", value: "general_commercial" },
      { label: "Other Retail", value: "other_retail" },
      { label: "General Retail", value: "general_retail" },
      { label: "Street Retail", value: "street_retail" }
    ]
  },
  {
    label: "Multifamily",
    value: "multifamily",
    subtypes: [
      { label: "Low-Rise", value: "low-rise" },
      { label: "Mid-Rise", value: "mid-rise" },
      { label: "Garden", value: "garden" },
      { label: "Senior Housing", value: "senior_housing" },
      { label: "Other Multifamily", value: "other_multifamily" },
      { label: "Townhouse", value: "townhouse" },
      { label: "Student Housing", value: "student_housing" },
      { label: "Government Subsidized", value: "government_subsidized" },
      { label: "Multi-Family", value: "multi-family" }
    ]
  },
  {
    label: "Industrial",
    value: "industrial",
    subtypes: [
      { label: "General Commercial", value: "general_commercial" },
      { label: "Manufacturing", value: "manufacturing" },
      { label: "Flex", value: "flex" },
      { label: "Other Industrial", value: "other_industrial" },
      { label: "Warehouse", value: "warehouse" },
      { label: "Mixed-use", value: "mixed-use" },
      { label: "Processing", value: "processing" },
      { label: "Flex Space", value: "flex_space" },
      { label: "Data Center", value: "data_center" },
      { label: "R&D", value: "r&d" }
    ]
  },
  {
    label: "Health Care",
    value: "health_care",
    subtypes: [
      { label: "Veterinary hospital", value: "veterinary_hospital" },
      { label: "Senior Care Home", value: "senior_care_home" },
      { label: "Clinical", value: "clinical" },
      { label: "Senior Care", value: "senior_care" },
      { label: "Care Facility", value: "care_facility" },
      { label: "Medical Center", value: "medical_center" },
      { label: "Urgent Care Center", value: "urgent_care_center" },
      { label: "Rehabilitation Center", value: "rehabilitation_center" },
      { label: "Assisted Living", value: "assisted_living" },
      { label: "Senior Care Facility", value: "senior_care_facility" },
      { label: "Medical Office Building", value: "medical_office_building" },
      { label: "Behavioral Care Facility", value: "behavioral_care_facility" },
      { label: "Other Healthcare", value: "other_healthcare" },
      { label: "Medical Clinic", value: "medical_clinic" },
      { label: "Hospital", value: "hospital" },
      { label: "Clinic", value: "clinic" },
      { label: "Senior Housing", value: "senior_housing" },
      { label: "Medical office", value: "medical_office" },
      { label: "General Commercial", value: "general_commercial" },
      { label: "Laboratory", value: "laboratory" },
      { label: "Medical", value: "medical" }
    ]
  },
  {
    label: "Hotels",
    value: "hotels",
    subtypes: [
      { label: "Low-Rise", value: "low-rise" },
      { label: "Bed and Breakfast", value: "bed_and_breakfast" },
      { label: "Mid-Rise", value: "mid-rise" },
      { label: "Full Service", value: "full_service" },
      { label: "Economy Hotel / Motel", value: "economy_hotel_/_motel" },
      { label: "Luxury", value: "luxury" },
      { label: "Economy", value: "economy" },
      { label: "Extended Stay", value: "extended_stay" },
      { label: "Motel", value: "motel" },
      { label: "Limited Service", value: "limited_service" },
      { label: "Bed & Breakfast", value: "bed_&_breakfast" },
      { label: "Hotel", value: "hotel" },
      { label: "Hotel/Motel", value: "hotel/motel" },
      { label: "Low-rise/Limited Service", value: "low-rise/limited_service" }
    ]
  },
  {
    label: "Special Purpose",
    value: "special_purpose",
    subtypes: [
      { label: "Museum/gallery", value: "museum/gallery" },
      { label: "Other", value: "other" },
      { label: "Golf Course", value: "golf_course" },
      { label: "Church", value: "church" },
      { label: "Recreation", value: "recreation" },
      { label: "Other Special Purpose", value: "other_special_purpose" },
      { label: "Vacant - Commercial", value: "vacant_-_commercial" },
      { label: "Religious", value: "religious" }
    ]
  },
  { label: "Land", value: "land" },
  { label: "Agriculture", value: "agriculture" },
  { label: "Manufacture Housing", value: "manufacture_housing" },
  { label: "Self Storage", value: "self_storage" },
  { label: "Hospitality", value: "hospitality" }
];



export const RATING_VALUES = ['Excellent', 'VeryGood', 'Good', 'AboveAverage', 'Average', 'BelowAverage', 'Fair']

export const ZONING_OPTIONS = [
  { id: 'zoning-Multifamily', value: 'Multifamily', label: 'Multifamily' },
  { id: 'zoning-Agriculture', value: 'Agriculture', label: 'Agriculture' },
  { id: 'zoning-Commercial', value: 'Commercial', label: 'Commercial' },
  { id: 'zoning-Industrial', value: 'Industrial', label: 'Industrial' },
  { id: 'zoning-Residential', value: 'Residential', label: 'Residential' },
];

export const BY_DEFAULT_DISTANCE=5000;

export const DATA_STRUCTURE_COLUMN_HEADINGS = [
    { key: 'field', label: 'Field Key', type: 'text', required: true },
    { key: 'name', label: 'Field Name', type: 'text', required: true },
    { key: 'type', label: 'Field Type', type: 'select', options: FIELD_TYPES, required: true },
    { key: 'unit', label: 'Field Unit', type: 'select', options: UNIT_TYPES },
    { key: 'subunit', label: 'Field Sub Unit', type: 'select', options: SUB_MARKET },
    { key: 'validations', label: 'Validations', type: 'multi-select', options: VALIDATION_RULES },
    { key: 'visible', label: 'Visible', type: 'select', options: BOOLEAN_OPTION_LABELS, required: true },
    { key: 'description', label: 'Description', type: 'textarea', required: true },
    { key: 'enable_adjustment', label: 'Enable Adjustment', type: 'select', options: BOOLEAN_OPTION_LABELS },
    { key: 'adjustment_type', label: 'Adjustment Type', type: 'text' },
    { key: 'formula', label: 'Adjustment Formula', type: 'text' },
    { key: 'is_summary', label: 'Summary Field', type: 'select', options: BOOLEAN_OPTION_LABELS },
    { key: 'show_header', label: 'Show Header', type: 'select', options: BOOLEAN_OPTION_LABELS },
    { key: 'header_title', label: 'Grouping Title', type: 'text' },
    { key: 'actions', label: 'Actions', type: 'action' },
];

export const INDEX_MULTIPLIER:number=100000;
